/**
 * @file     rentalsListing.ts
 * @readme   ../CLAUDE.md
 * @purpose  Side-effect import: registers the English `rentalsListing` strings. Every file that references `rentalsListing.*` keys imports this (pnpm lint:i18n-deferred).
 */
import { rentalsListing } from '../resources/en/rentalsListing';
import { registerEnglish } from './registerEnglish';

registerEnglish({ rentalsListing });
